import CashfreeLogo from '@assets/payment-modes/cashfree.svg';
import PaypalLogo from '@assets/payment-modes/paypal.svg';
import PhonePeLogo from '@assets/payment-modes/phonepe.svg';
import StripeLogo from '@assets/payment-modes/stripe.svg';

export enum ProfileVerifications {
  AADHAAR = 'aadhaar',
  PASSPORT = 'passport',
  DRIVING_LICENSE = 'dl',
  EMPLOYMENT = 'employment-check',
  BGV_DEGREE = 'bgv-degree',
  BGV_TWELFTH = 'bgv-twelfth',
  BGV_TENTH = 'bgv-tenth',
  BGV_EMPLOYMENT = 'bgv-employment'
}

export enum VerificationCategories {
  IDENTITY = 'Identity',
  EDUCATION = 'Education',
  FINANCE = 'Finance',
  EMPLOYMENT = 'Employment',
  ADDRESS = 'Address'
}

/**
 * Verification Txn States:
 * @see {@link TxnState.NOT_INITIALIZED},
 * @see {@link TxnState.DATA_SAVED} ,
 * @see {@link TxnState.IN_PROGRESS},
 * @see {@link TxnState.COMPLETED},
 * @see {@link TxnState.FAILED},
 * @see {@link TxnState.INSUFFICIENT_DATA},
 *
 * Payment States:
 * @see {@link TxnState.VERIFIED}
 * @see {@link TxnState.SUCCESS}
 * @see {@link TxnState.PENDING}
 * @see {@link TxnState.REFUNDED}
 */
export enum TxnState {
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  DATA_SAVED = 'DATA_SAVED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  CLOSED = 'CLOSED',
  SKIPPED = 'SKIPPED',
  SUBMITTED = 'SUBMITTED',
  VERIFIED = 'VERIFIED',
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  REFUNDED = 'REFUNDED',
  READY_TO_SUBMIT = 'READY_TO_SUBMIT'
}

export const paymentProvider = {
  phonepe: {
    name: 'PhonePe',
    logo: <img style={{ width: '4rem' }} src={PhonePeLogo} alt="PhonePe Logo" />,
    src: PhonePeLogo
  },
  'cashfree-sdk': {
    name: 'CashFree Payments',
    logo: <img style={{ width: '4rem' }} src={CashfreeLogo} alt="Cashfree Logo" />,
    src: CashfreeLogo
  },
  cashfree: {
    name: 'CashFree Payments',
    logo: <img style={{ width: '4rem' }} src={CashfreeLogo} alt="Cashfree Logo" />,
    src: CashfreeLogo
  },
  paypal: {
    name: 'PayPal',
    logo: <img style={{ width: '4rem' }} src={PaypalLogo} alt="PayPal Logo" />,
    src: PaypalLogo
  },
  'stripe-sdk': {
    name: 'Stripe Payments',
    logo: <img style={{ width: '4rem' }} src={StripeLogo} alt="Stripe Logo" />,
    src: StripeLogo
  },
  stripe: {
    name: 'Stripe Payments',
    logo: <img style={{ width: '4rem' }} src={StripeLogo} alt="Stripe Logo" />,
    src: StripeLogo
  }
};

export type paymentProvidersTypes =
  | 'phonepe'
  | 'cashfree'
  | 'cashfree-sdk'
  | 'paypal'
  | 'stripe-sdk'
  | 'stripe';

export const STATE_SORT_PRIORITY: Record<string, number> = {
  [TxnState.INSUFFICIENT_DATA]: 1, // Highest priority state
  [TxnState.READY_TO_SUBMIT]: 2,
  [TxnState.COMPLETED]: 3,
  [TxnState.FAILED]: 4,
  [TxnState.IN_PROGRESS]: 5,
  [TxnState.SUBMITTED]: 6,
  [TxnState.DATA_SAVED]: 7,
  [TxnState.NOT_INITIALIZED]: 8
};

export const INSUFF_CATEGORY = 'Action Required';

export const growthBookProfileVerificationsFeature = 'Verifications-For-Profile';
